var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value:
            _vm.searchIndex?.length &&
            _vm.searchKey?.length &&
            _vm.searchHost?.length,
          expression:
            "searchIndex?.length && searchKey?.length && searchHost?.length",
        },
      ],
      ref: "search",
      staticClass: "search--container",
      class: _vm.containerClasses,
      attrs: { role: "search" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
        },
        open: function ($event) {
          _vm.hideWidget = false
        },
        close: function ($event) {
          _vm.hideWidget = true
        },
        reset: _vm.reset,
      },
    },
    [
      _vm.minimizeWidget
        ? _c("a", {
            staticClass:
              "search--handle visual_menu--glass_effect textual_menu--glass_effect material-icons",
            attrs: {
              href: "#",
              title: _vm.hideWidget ? "Open Search" : "Close Search",
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.handleSearchHandleClick.apply(null, arguments)
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "viewport" },
        [
          _c("text-input", {
            ref: "input",
            attrs: {
              label: "Search Menu Items",
              type: "search",
              required: "",
              wide: "",
            },
            on: { focus: _vm.focusHandler },
            nativeOn: {
              input: function ($event) {
                return _vm.submitAutocomplete.apply(null, arguments)
              },
              search: function ($event) {
                return _vm.submitSearch.apply(null, arguments)
              },
            },
            model: {
              value: _vm.searchTerm,
              callback: function ($$v) {
                _vm.searchTerm = $$v
              },
              expression: "searchTerm",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          ref: "autocomplete",
          staticClass: "autocomplete_results--container",
          class: {
            "autocomplete_results--container-hide":
              !_vm.showResults || !_vm.autocompleteResults.length,
          },
          style: { "max-height": _vm.autocompleteMaxHeight },
        },
        [
          _vm._l(_vm.autocompleteResults, function (result, index) {
            return _c(
              "li",
              {
                key: index,
                staticClass: "autocomplete_results--content",
                on: {
                  click: function ($event) {
                    return _vm.handleResultClick(result)
                  },
                },
              },
              [
                _c("div", { staticClass: "autocomplete_results--menu_icon" }, [
                  _vm.allMenuIconsByTitle[result.menu].length
                    ? _c("i", { staticClass: "material-icons" }, [
                        _vm._v(_vm._s(_vm.allMenuIconsByTitle[result.menu])),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("span", {
                    domProps: {
                      innerHTML: _vm._s(_vm.getResultData(result, "menu")),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("div", [
                  _c("h4", {
                    staticClass: "autocomplete_results--menu_title",
                    domProps: { innerHTML: _vm._s(_vm.getResultTitle(result)) },
                  }),
                  _vm._v(" "),
                  _vm.getResultData(result, "mi_subtitle").length
                    ? _c("h5", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getResultData(result, "mi_subtitle")
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.getResultData(result, "mi_description")
                    ? _c("p", {
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.getResultData(result, "mi_description")
                          ),
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.getResultData(result, "tags")),
                    },
                  }),
                ]),
                _vm._v(" "),
                _c("a", {
                  staticClass:
                    "item_button--container item_button--container-view material-icons",
                  attrs: {
                    href: "#",
                    title: "Click to view " + result.mi_title,
                  },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      $event.stopPropagation()
                      return _vm.handleResultClick(result)
                    },
                  },
                }),
              ]
            )
          }),
          _vm._v(" "),
          !_vm.autocompleteResults.length
            ? _c("li", [_c("i", [_vm._v("No Results Found")])])
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", {
        staticClass: "search--overlay",
        class: { "search--overlay-active": !_vm.hideWidget },
        on: {
          click: function ($event) {
            _vm.hideWidget = true
          },
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }